<template>
  <div role="main">
    <b-row>
      <b-col cols="12" md="4" sm="12">
        <div class="ibox">
          <div id="d-table-scroll" class="ibox-title">
            <span>
              Create New Account
            </span>
          </div>
          <div class="ibox-content p-3">
            <b-form v-on:submit.prevent="handleSubmitUserCreate">
              <b-form-group id="group-account-create-input-username"
                label="Username:"
                label-for="account-create-input-username"
                :state="stateValidateUsernameUserCreate"
                :invalid-feedback="invalidFeedbackUsernameUserCreate"
                :valid-feedback="validFeedbackUsernameUserEdit">
                <b-form-input id="account-create-input-username"
                  type="text"
                  name="username"
                  required
                  placeholder="Enter username"
                  :disabled="userCreate.progress"
                  :state="stateValidateUsernameUserCreate"
                  v-model.trim="userCreate.input.username">
                </b-form-input>
              </b-form-group>
              <b-form-group id="group-account-create-input-password"
                label="Password:"
                label-for="account-create-input-password"
                :state="stateValidatePasswordUserCreate"
                :invalid-feedback="invalidFeedbackPasswordUserCreate"
                :valid-feedback="validFeedbackPasswordUserEdit">
                <b-form-input id="account-create-input-password"
                  autocomplete="off"
                  type="text"
                  name="password"
                  required
                  placeholder="Enter password"
                  :disabled="userCreate.progress"
                  :state="stateValidatePasswordUserCreate"
                  v-model.trim="userCreate.input.password">
                </b-form-input>
              </b-form-group>
              <b-btn type="submit"
                variant="dark"
                :disabled="userCreate.progress || ( false == stateValidateUsernameUserCreate || false == stateValidatePasswordUserCreate )">
                Submit
              </b-btn>
            </b-form>
          </div>
        </div>
      </b-col>
      <b-col cols="12" md="8" sm="12">
        <div class="ibox">
          <div id="d-table-scroll" class="ibox-title">
            <span>
              List Accounts
            </span>
            <div class="ibox-tools">
              <div role="group" arial-label="Action" class="btn-group btn-group-sm">
                <b-btn variant="secondary" v-on:click="requestData">
                  <font-awesome-icon icon="sync-alt" :spin="processing" />
                </b-btn>
              </div>
            </div>
          </div>

          <div class="ibox-content">
            <div class="table-beauty">
                <div class="beauty-scoped">
                  <div class="table-responsive">
                    <table class="table table-hover table-bordered has-paging">
                      <thead>
                        <tr>
                          <th scope="col" class="sorting" style="width: 11rem">
                            Created
                            <a
                              href="#"
                              :class="getOrderByClass( 'created_at' )"
                              v-on:click="toggleOrderBy( $event, 'created_at'  )"/>
                          </th>
                          <th scope="col" class="sorting">
                            ID
                            <a
                              href="#"
                              :class="getOrderByClass( 'username' )"
                              v-on:click="toggleOrderBy( $event, 'username'  )"/>
                          </th>
                          <th scope="col" class="sorting">
                            Role
                            <a
                              href="#"
                              :class="getOrderByClass( 'role' )"
                              v-on:click="toggleOrderBy( $event, 'role'  )"/>
                          </th>
                          <th scope="col" class="sorting" style="width: 3rem">
                            Action
                            <a href="#" class="sorting_disabled"/>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr class="odd" v-if="processing && !table.initial">
                          <td valign="center" colspan="5" class="no-hover">
                            <div class="loading-spinner"><div class="spin">Loading...</div></div>
                          </td>
                        </tr>
                        <tr class="odd" v-if="!table.rows.length && table.initial">
                          <td valign="top" colspan="5" class="no-hover text-center">No data available in table</td>
                        </tr>
                        <tr role="row" v-for="(item, index) in table.rows" v-bind:key="index" :class="index % 2 ? 'even' : 'odd'">
                          <td class="text-nowrap">{{ item.created_at }}</td>
                          <td class="text-nowrap">{{ item.username }}</td>
                          <td class="text-nowrap">{{ ( item.role ? item.role.name : '' ) }}</td>
                          <td>
                            <b-button-group size="sm">
                              <b-btn
                                variant="primary"
                                @click="modalUserEdit.show=true;modalUserEdit.data.id=item.id;modalUserEdit.data.username=item.username">
                                <font-awesome-icon icon="edit"/>
                              </b-btn>
                              <b-btn variant="danger" @click="handleDeketeUser( item.username )">
                                <font-awesome-icon icon="trash-alt"/>
                              </b-btn>
                            </b-button-group>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="table-beaury-loading" v-if="processing && table.initial"/>
                  </div>
                </div>
                <div class="row table-beauty-bottom" v-show="table.initial">
                  <div class="col-sm-12 col-md-5">
                    <div class="table-beauty-info" aria-live="polite"> Showing {{ table.rows.length ? ( table.pagination.offset + 1 ) : 0 }} to {{ table.rows.length + table.pagination.offset }} of {{ table.countAll }} entries</div>
                  </div>
                  <div class="col-sm-12 col-md-7">
                    <div class="table-beauty-paginate" aria-label="Page navigation conversions">
                      <ul class="pagination">
                        <li class="page-item" :class="{ 'disabled': !table.prev }">
                          <a href="#" class="page-link" v-on:click="goTablePage( $event, ( table.pagination.current - 1 ) )">Previous</a>
                        </li>
                        <li class="page-item" v-for="n in table.pagination.total" v-bind:key="n" :class="table.pagination._current == n ? 'active' : ''">
                          <a href="#" class="page-link" v-on:click="goTablePage( $event, n )">{{ n }}</a>
                        </li>
                        <li class="page-item" :class="{ 'disabled': !table.next }">
                          <a href="#" class="page-link" aria-label="Next" v-on:click="goTablePage( $event, ( table.pagination.current + 1 ) )"> Next</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-modal id="edit-user"
      ref="edit-user"
      title="Edit user"
      ok-variant="dark"
      cancel-variant="danger"
      header-bg-variant="dark"
      header-text-variant="light"
      v-model="modalUserEdit.show"
      @shown="handleModalShownUserEdit"
      @hidden="handleModalHiddenUserEdit"
      @ok="handleModalOkUserEdit"
      :ok-disabled="modalUserEdit.progress !== false || !stateValidateUserEdit || modalUserEdit.okDisable"
      :lazy="true">
      <div class="loading-spinner" v-if="modalUserEdit.progress">
        <div class="spin">Loading...</div>
      </div>
      <b-form v-else v-on:submit.prevent="handleModalSubmitUserEdit">
        <b-form-group id="group-account-edit-input-username"
          label="Username:"
          label-for="user-edit-input-username">
          <b-form-input id="user-edit-input-username"
            type="text"
            placeholder="Enter username"
            name="username"
            disabled
            v-model.trim="modalUserEdit.data.username">
          </b-form-input>
        </b-form-group>
        <b-form-group id="group-account-edit-password"
          label="Password:"
          label-for="user-edit-input-password"
          :state="stateValidateUserEdit"
          :invalid-feedback="invalidFeedbackUserEdit"
          :valid-feedback="validFeedbackUserEdit">
          <b-form-input id="user-edit-input-password"
            type="text"
            placeholder="Enter new password"
            autocomplete="off"
            name="password"
            required
            :state="stateValidateUserEdit"
            v-model.trim="modalUserEdit.input.password">
          </b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
  const Cookies = require( 'js-cookie' );
  const moment = require('moment');
  const axios = require('axios');
  const CancelToken = axios.CancelToken;

  export default {
    data () {
      return {
        title: '',
        processing: false,
        filter: {
          date: 'today',
          user: ''
        },
        table: {
          initial: false,
          countAll: 0,
          pagination: {
            offset: 0,
            current: 1,
            _current: 1,
            total: 0,
            prev: false,
            next: false
          },
          rows: [],
          requestCancel: null,
          orderBy: {
            key: 'created_at',
            type: 'desc'
          },
          tempOrderBy: {
            key: 'created_at',
            type: 'desc'
          }
        },
        userCreate: {
          progress: false,
          input: {
            username: null,
            password: null
          }
        },
        modalUserEdit: {
          show: false,
          progress: true,
          id: null,
          okDisable: false,
          data: {
            id: null,
            username: null
          },
          input: {
            old_password: null,
            password: null
          }
        }
      };
    },
    computed: {
      stateValidateUsernameUserCreate() {
        if ( !this.userCreate.input.username ) {
          return false;
        }

        const validation = this.userValidation( {
          username: this.userCreate.input.username
        } );

        return validation.invalid.username ? false : true;
      },
      stateValidatePasswordUserCreate() {
        if ( !this.userCreate.input.password ) {
          return false;
        }

        const validation = this.userValidation( {
          password: this.userCreate.input.password
        } );

        return validation.invalid.password ? false : true;
      },
      invalidFeedbackUsernameUserCreate() {
        const validation = this.userValidation( {
          username: this.userCreate.input.username
        } );

        if ( validation.error && validation.invalid.username ) {
          return validation.invalid.username;
        }

        return '';
      },
      invalidFeedbackPasswordUserCreate() {
        const validation = this.userValidation( {
          password: this.userCreate.input.password
        } );

        if ( validation.error && validation.invalid.password ) {
          return validation.invalid.password;
        }

        return '';
      },
      validFeedbackUsernameUserEdit() {
        return this.stateValidateUsernameUserCreate === false ? '' : '';
      },
      validFeedbackPasswordUserEdit() {
        return this.stateValidatePasswordUserCreate === false ? '' : '';
      },
      stateValidateUserEdit() {
        if ( !this.modalUserEdit.input.password ) {
          return false;
        }

        const validation = this.userValidation( {
          password: this.modalUserEdit.input.password
        } );
        return validation.invalid.password ? false : true;
      },
      invalidFeedbackUserEdit() {
        const validation = this.userValidation( {
          password: this.modalUserEdit.input.password
        } );

        if ( validation.error && validation.invalid.password ) {
          return validation.invalid.password;
        }

        return '';
      },
      validFeedbackUserEdit() {
        return this.stateValidateUserEdit === false ? '' : '';
      }
    },
    created() {
      this.requestData();

      const { user } = this.$store.state.authentication;
      const { permissions } = this.$route.meta;

      if ( permissions && user.role ) {
        if ( permissions.role !== user.role.slug ) {
          this.$router.push('/');
        }
      }
    },
    filters: {
      capitalizeFirstLetter: value => {
        if ( !value ) {
          return '';
        }

        return value.charAt(0).toUpperCase() + value.slice(1);
      }
    },
    methods: {
      userValidation( content ) {
        const result = { invalid: { }, error: false };
        // eslint-disable-next-line
        let username = content ? content.username : null;
        let password = content ? content.password : null;

        if ( username ) {
          if ( username.length <= 2 ) {
            result.error = true;
            result.invalid.username = 'Enter at least 3 characters';
          }
          else {
            const nameRegex = /^[a-zA-Z0-9]+$/;
            if ( null == username.match( nameRegex ) ) {
              result.error = true;
              result.invalid.username = 'Invalid username';
            }
            else {
              result.error = true;
              result.invalid.username = '';
            }
          }
        }

        if ( password ) {
          if ( password.length <= 4 ) {
            result.error = true;
            result.invalid.password = 'Enter at least 4 characters';
          }
          else if ( password.length >= 100 ) {
            result.error = true;
            result.invalid.password = 'A maximum of 100 characters';
          }
          else {
            result.error = true;
            result.invalid.password = '';
          }
        }

        return result;
      },
      handleSubmitUserCreate( event ) {
        if ( event && event.preventDefault ) {
          event.preventDefault();
        }

        const token = Cookies.get('__token');
        const { username, password } = this.userCreate.input;
        const url = `/api/account/create`;

        const instance = axios.create( {
          baseURL: process.env.VUE_APP_API_URL
        } );

        instance.interceptors.request.use( config => {
          config.headers['Authorization'] = `Bearer ${token}`;
          this.userCreate.progress = true;
          return config;
        }, error => {
          return Promise.reject( error );
        });

        instance.post( url, {
          username: username,
          password: password
        } ).then( response => {
          const data = response.data;

          if ( true === data.result ) {
            this.userCreate.input.username = null;
            this.userCreate.input.password = null;

            this.requestData();
          }
          else {
            alert( 'Kesalahan respon dari server, silahkan coba lagi nanti.' );
          }

          this.userCreate.progress = false;
        } ).catch( error => {
          if ( !error ) {
            alert('Tidak dapat terhubung dengan server');
          }
          else {
            const data = error.response.data;

            if ( data.error && data.error.message ) {
              alert( 'Error: ' + data.error.message );
            }
          }

          this.userCreate.progress = false;
        } );

      },
      handleModalShownUserEdit() {
        const token = Cookies.get('__token');
        const { username } = this.modalUserEdit.data;
        const url = `/api/account/edit/${username}/modal-open`;

        const instance = axios.create( {
          baseURL: process.env.VUE_APP_API_URL
        } );

        instance.interceptors.request.use( config => {
          config.headers['Authorization'] = `Bearer ${token}`;
          this.modalUserEdit.progress = true;
          return config;
        }, error => {
          return Promise.reject( error );
        });

        instance.get( url ).then( () => {
          this.modalUserEdit.progress = false;
        } ).catch( error => {
          if ( !error ) {
            alert('Tidak dapat terhubung dengan server');
          }
          else {
            const data = error.response.data;

            if ( data.error && data.error.message ) {
              alert( 'Error: ' + data.error.message );
            }
          }

          this.modalUserEdit.progress = false;
        } );
      },
      handleModalHiddenUserEdit() {
        this.modalUserEdit.data.id = null;
        this.modalUserEdit.data.username = null;
        this.modalUserEdit.progress = false;
        this.modalUserEdit.input.password = null;
      },
      handleModalOkUserEdit( event ) {
        event.preventDefault();

        if ( !this.modalUserEdit.input.password ) {
          alert('Please enter someting in new password!');
        } else {
          this.handleModalSubmitUserEdit();
        }
      },
      handleModalSubmitUserEdit() {
        const token = Cookies.get('__token');
        const { username } = this.modalUserEdit.data;
        const url = `/api/account/edit/${username}/modal-open`;

        const instance = axios.create( {
          baseURL: process.env.VUE_APP_API_URL
        } );

        instance.interceptors.request.use( config => {
          config.headers['Authorization'] = `Bearer ${token}`;
          this.modalUserEdit.progress = true;
          return config;
        }, error => {
          return Promise.reject( error );
        });

        instance.post( url, {
          password: this.modalUserEdit.input.password
        } ).then( response => {
          const data = response.data;
          if ( true === data.result ) {
            if ( true == this.$refs.hasOwnProperty( 'edit-user' ) ) {
              if ( this.$refs['edit-user'] ) {
                this.$refs['edit-user'].hide();
              }
            }
          }
          else {
            alert( 'Error: Kesalahan tidak diketahui' );
          }

          this.modalUserEdit.progress = false;
        } ).catch( error => {
          if ( !error ) {
            alert('Tidak dapat terhubung dengan server');
          }
          else {
            const data = error.response.data;

            if ( data.error && data.error.message ) {
              alert( 'Error: ' + data.error.message );
            }
          }

          this.modalUserEdit.progress = false;
        } );

      },
      handleDeketeUser( username ) {
        const respond = confirm(`Yakin username "${username}" ingin dihapus?`);
        if ( true !== respond ) {
          return;
        }

        const token = Cookies.get('__token');
        const url = `/api/account/delete`;

        const instance = axios.create( {
          baseURL: process.env.VUE_APP_API_URL
        } );

        instance.interceptors.request.use( config => {
          config.headers['Authorization'] = `Bearer ${token}`;
          return config;
        }, error => {
          return Promise.reject( error );
        });

        instance.post( url, {
          username: username
        } ).then( () => {
          this.requestData();
        } ).catch( error => {
          if ( !error ) {
            alert('Tidak dapat terhubung dengan server');
          }
          else {
            const data = error.response.data;

            if ( data.error && data.error.message ) {
              alert( 'Error: ' + data.error.message );
            }
          }
        } );
      },
      getOrderByClass( key ) {
        const typeToClass = ( src ) => {
          if ( src === 'desc' ) {
            return 'sorting_desc';
          }
          if ( src === 'asc' ) {
            return 'sorting_asc';
          }
        };

        if ( this.table.orderBy.key === key ) {
          return typeToClass( this.table.orderBy.type );
        }

        return 'sorting';
      },
      toggleOrderBy( event, key ) {
        let type = 'asc';

        if ( this.table.orderBy.key === key ) {
          if ( this.table.orderBy.type === 'desc' ) {
            type = 'asc';
          }
          else {
            type = 'desc';
          }
        }

        if ( event.preventDefault ) {
          event.preventDefault();
          this.table.tempOrderBy = { key: key, type: type };
        }
        else {
          this.table.tempOrderBy = { key: event, type: type };
        }

        this.requestData();
      },
      requestData() {
        const url = `${process.env.VUE_APP_API_URL}/api/accounts/${this.table.pagination.current}`;
        const token = Cookies.get('__token');
        const dataParams = { };

        dataParams['order-by'] = this.table.tempOrderBy;

        if ( this.filter.user && this.filter.user.trim().length ) {
          dataParams.user = this.filter.user.trim();
        }

        if ( this.requestCancel ) {
          this.requestCancel( 'Request cancel' );
        }

        const instance = axios.create( );

        instance.interceptors.request.use( config => {
          config.headers['Authorization'] = `Bearer ${token}`;
          this.processing = true;
          return config;
        }, error => {
          return Promise.reject( error );
        });

        return instance.get( url, {
          cancelToken: new CancelToken( cancel => {
            this.requestCancel = cancel;
          }),
          params: dataParams
        } ).then( response => {
          const data = response.data;

          data.rows.map( item => {
            if ( item.created_at ) {
              item.created_at = moment( item.created_at )
                .utcOffset('UTC+07:00')
                .format('DD/MM/YYYY, hh:mm:ss A');
            }

            return item;
          } );

          this.table.rows = data.rows;
          this.table.countAll = data.total;
          this.table.pagination.offset = data.pagination.offset;
          this.table.pagination.current = data.pagination.current;
          this.table.pagination._current = data.pagination.current;
          this.table.pagination.total = data.pagination.total;

          this.table.orderBy = this.table.tempOrderBy;

          // <-- start set pagination

          if ( 1 == data.pagination.current || 1 >= data.pagination.current ) {
            this.table.prev = false;
          }
          else {
            this.table.prev = true;
          }

          if ( data.pagination.total == data.pagination.current || data.rows.length <= 1 ) {
            this.table.next = false;
          }
          else {
            this.table.next = true;
          }

          // <--end set pagination

          if ( false === this.table.initial ) {
            this.table.initial = true;
          }

          this.processing = false;

          return response;
        } ).catch( error => {
          if ( false === axios.isCancel( error ) ) {
            if ( false === this.table.initial ) {
              this.table.initial = true;
            }

            this.processing = false;
          }

          if ( !error ) {
            alert('Tidak dapat terhubung dengan server');
          }
          else {
            const data = error.response.data;

            if ( data.code == 'auth' ) {
              this.$store.dispatch( 'authentication/logout' );
              this.$router.push('/login');
            }
          }

          throw error;
        } );
      },
      goTablePage( event, page ) {
        if ( event ) {
          event.preventDefault();

          const me = event.currentTarget;
          const item = me.closest('.page-item');

          if (item.classList.length && -1 !== item.className.split(' ').indexOf('active')) {
            return;
          }
        }

        this.table.pagination.current = page;

        this.requestData();
      },
      onSubmitFilter( event ) {
        event.preventDefault();

        this.requestData();
      }
    },
    beforeRouteLeave( to, from, next ) {
      this.processing = true;
      next();
    }
  };
</script>